
const _ = require('lodash');

import ko from 'rgs-knockout';

const kladrUtils = require('kladr-utils');

const { JSableOmitPrivate } = require('jsable');

import ObservableMap from 'observable-map';


const streets = new ObservableMap;
const settlements = new ObservableMap;
const settlementsRsa = new ObservableMap;

class AddressComponent extends JSableOmitPrivate {
	constructor (options) {
		super();

		this._options = _.defaults({}, options, this._getDefaultOptions());

		const { parent, dictionary } = this._options;

		this.Kladr = ko.observable()
			.extend({ toFromJS: true });

		this.Name = ko.pureComputed({
			read: () => {
				return dictionary.get(this.Kladr());
			},
			write: (name) => {
				if (!name) {
					this.Kladr(null);
				} else {
					const id = dictionary.get(name);
					if (id) {
						this.Kladr(id);
					}
				}
			},
		})
			.extend({ toJS: true })
			.extend({
				debug: {
					name: 'AddressComponent.Name',
					owner: parent,
				},
			});
	}

	_getDefaultOptions () {
		return {};
	}

	repr () {
		return this.Name();
	}

	fromJS (js) {
		if (js
			&& js.Kladr
			&& js.Name
		) {
			this._options.dictionary.bisetAbsent(
				js.Kladr,
				js.Name
			);
		}

		return super.fromJS(...arguments);
	}
}

class AddressStreetComponent extends AddressComponent {
	constructor (...args) {
		super(...args);

		const { parent } = this._options;

		this.Kladr = ko.map(this.Kladr, {
			mapRead: _.flowRight(
				(v) => parent.HasStreets() ? v : null,
				(v) => {
					const settlementKladr = parent.Settlement.Kladr();
					if (!settlementKladr) {
						return v;
					}
					return kladrUtils.contains(settlementKladr, v)
						? v
						: null;
				}
			),
		})
			.extend({ toFromJS: true });
	}

	_getDefaultOptions () {
		return {
			dictionary: streets,
		};
	}
}

class AddressSettlementComponent extends AddressComponent {
	constructor (options) {
		super(options);

		const { dictionaryRsa } = this._options;

		this.NameRsa = ko.pureComputed({
			read: () => {
				return dictionaryRsa.get(this.Kladr())
					|| this.Name();
			},
			write: (name) => {
				if (!name) {
					this.Kladr(null);
				} else {
					const id = dictionaryRsa.get(name);
					if (id) {
						this.Kladr(id);
					}
				}
			},
		})
			.extend({ toJS: true })
			.extend({
				debug: 'AddressComponent.NameRsa',
			});
	}

	repr () {
		return this.NameRsa() || super.repr(...arguments);
	}

	toJS (...args) {
		const js = super.toJS(...args);

		if (js && _.isString(js.Kladr)) {
			js.Kladr = kladrUtils.convertKladrToNumber(js.Kladr);
		}

		return js;
	}

	fromJS (js) {
		if (js
			&& js.Kladr
			&& js.NameRsa
		) {
			this._options.dictionaryRsa.bisetAbsent(
				js.Kladr,
				js.NameRsa
			);
		}

		return super.fromJS(...arguments);
	}

	_getDefaultOptions () {
		return {
			dictionary: settlements,
			dictionaryRsa: settlementsRsa,
		};
	}
}

class Address extends JSableOmitPrivate {
	constructor (options) {
		options = _.defaultsDeep({}, options, {
			dictionaries: {
				kladr: {
					streets,
					settlements,
					settlementsRsa,
				},
			},
		});

		super();

		this._options = options;

		this.Kladr = ko.pureComputed(() => kladrUtils.mostAccurate([
			this.Street.Kladr(),
			this.Settlement.Kladr(),
		])).extend({ toJS: true });

		this.Apartement = ko.observable()
			.extend({ toFromJS: true })
			.extend({ repr: _.identity });

		this.House = ko.observable()
			.extend({ toFromJS: true })
			.extend({ repr: _.identity });

		this.HasStreets = ko.observable(true).extend({ toFromJS: true });

		this.Street = this._newAddressStreetComponent({
			dictionary: options.dictionaries.kladr.streets,
			parent: this,
		});

		this.Settlement = this._newAddressSettlementComponent({
			dictionary: options.dictionaries.kladr.settlements,
			dictionaryRsa: options.dictionaries.kladr.settlementsRsa,
			parent: this,
		});
	}

	repr () {
		const settlement = this.Settlement.repr();
		const street = this.Street.repr();
		const house = this.House.repr();
		const apartement = this.Apartement.repr();
		return _([
			settlement,
			street,
			house,
			apartement,
		])
			.map(_.trim)
			.filter(_.identity)
			.join(', ');
	}

	_newAddressStreetComponent (...args) {
		return new AddressStreetComponent(...args);
	}

	_newAddressSettlementComponent (...args) {
		return new AddressSettlementComponent(...args);
	}
}

class AddressLite extends JSableOmitPrivate {
	constructor (options) {
		options = _.defaultsDeep({}, options, {
			dictionaries: {
				kladr: {
					settlements,
					settlementsRsa,
				},
			},
		});

		super();

		this._options = options;

		const dictionary = options.dictionaries.kladr.settlements;
		const dictionaryRsa = options.dictionaries.kladr.settlementsRsa;

		this.SettlementKladr = ko.observable()
			.extend({ toFromJS: true });

		this.SettlementName = ko.pureComputed({
			read: () => {
				return dictionary.get(this.SettlementKladr());
			},
			write: (name) => {
				if (!name) {
					this.SettlementKladr(null);
				} else {
					const id = dictionary.get(name);
					if (id) {
						this.SettlementKladr(id);
					}
				}
			},
		})
			.extend({ toFromJS: true });

		this.SettlementNameRsa = ko.pureComputed({
			read: () => {
				return dictionaryRsa.get(this.SettlementKladr())
					|| this.SettlementName();
			},
			write: (name) => {
				if (!name) {
					this.SettlementKladr(null);
				} else {
					const id = dictionaryRsa.get(name);
					if (id) {
						this.SettlementKladr(id);
					}
				}
			},
		})
			.extend({ toFromJS: true });
	}

	toJS (...args) {
		const js = super.toJS(...args);

		if (js) {
			if (_.isString(js.SettlementKladr)) {
				js.SettlementKladr = kladrUtils.convertKladrToNumber(js.SettlementKladr);
			}

			if (!js.SettlementName && js.SettlementNameRsa) {
				js.SettlementName = js.SettlementNameRsa;
			}
		}

		return js;
	}

	fromJS (js) {
		if (js && js.SettlementKladr
		) {
			if (js.SettlementName) {
				this._options.dictionaries.kladr.settlements.bisetAbsent(
					js.SettlementKladr,
					js.SettlementName
				);
			}

			if (js.SettlementNameRsa) {
				this._options.dictionaries.kladr.settlementsRsa.bisetAbsent(
					js.SettlementKladr,
					js.SettlementNameRsa
				);
			}
		}

		return super.fromJS(...arguments);
	}
}

module.exports = {
	Address,
	AddressLite,
	AddressComponent,
	AddressStreetComponent,
	AddressSettlementComponent,
};
